'use client'

import { useMergeRefs } from '@floating-ui/react'
import React, {
  cloneElement,
  FC,
  HTMLProps,
  isValidElement,
  ReactElement,
  ReactNode
} from 'react'
import { useTooltipContext } from './tooltip'

type TooltipTriggerProps = (
  | {
      asChild?: true
      children?: ReactElement<$TSFixMe>
    }
  | {
      asChild?: false
      children: ReactNode
    }
) &
  HTMLProps<HTMLButtonElement>

export const TooltipTrigger: FC<TooltipTriggerProps> = ({
  children,
  asChild = false,
  ref,
  ...props
}) => {
  const { refs, getReferenceProps, open } = useTooltipContext()

  /*
   * Note it is needed for managing tooltip with other floating components
   * for example Tooltip with Dropdown, Combobox, etc.
   */
  const mergedRef = useMergeRefs([
    ref,
    (children as $TSFixMe)?.ref,
    refs.setReference
  ])

  // `asChild` allows the user to pass any element as the anchor
  if (asChild && isValidElement(children)) {
    return cloneElement(
      children,
      getReferenceProps({
        ...props,
        ...children.props,
        ref: mergedRef,
        'data-state': open ? 'open' : 'closed',
        'aria-label': children.props['aria-label'] || props['aria-label']
      })
    )
  }

  // @TODO Feshchenko: Replace with button component after implementation
  return (
    <button
      // The user can style the trigger based on the state
      data-state={open ? 'open' : 'closed'}
      {...getReferenceProps({
        ...props,
        ref: mergedRef
      })}>
      {children}
    </button>
  )
}
